import * as React from "react";
const IconSearch = ({ fill = "#212A3D", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "1em"}
    height="1em"
    fill={fill}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10"
      clipRule="evenodd"
    />
  </svg>
);
export default IconSearch;
